import { render, staticRenderFns } from "./EventCreate.vue?vue&type=template&id=2aed48b4&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventCreate.vue"
export default component.exports